import styled from 'styled-components';
import ReactSelect from 'react-select';

const Select = styled(ReactSelect)`
  font-weight: bold;
  & .Select__control {
    background-color: ${props => props.theme.select.main};
  }
  & .Select__placeholder {
    color: ${props => props.theme.select.placeholder}
    font-size: 14px;
    top: 55%;
  }
  & .Select__indicator-separator {
    display: none;
  }
  & .Select__indicator {
    &:hover {
      color: ${props => props.theme.select.indicatorHover}
    }
    color: ${props => props.theme.select.indicator}
  }
  & .Select__single-value {
    color: ${props => props.theme.select.selected}
    font-size: 14px;
    line-height: 20px;
    top: 55%;
  }
  & .Select__control {
    border: none;
    border-radius: 0px;
    cursor: pointer;
  }
  & .Select__control--menu-is-open {
  }
  & .Select__menu {
    font-size: 14px;
    padding: 0;
    color: ${props => props.theme.select.menuOption}
  }
`;

export default Select;
